import globalStore from '$$globalStore';
import Filter from '../../../views/ganttView/controllers/filter';

export default instance => {
  // Events from Store
  const storeSubscription = globalStore.subscribe(async (mutation, state) => {
    if (mutation.payload?.fromGantt) {
      return;
    }

    if (mutation.type.includes('filter/updateCurrentFilter')) {
      Filter.run();
    }
  });

  const appSubscriptions = [];

  return {
    storeSubscription,
    appSubscriptions,
  };
};
